import { render, staticRenderFns } from "./cadcategorias.vue?vue&type=template&id=0af0994e&"
import script from "./cadcategorias.vue?vue&type=script&lang=js&"
export * from "./cadcategorias.vue?vue&type=script&lang=js&"
import style0 from "./cadcategorias.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports